import { NextPage } from 'next';
import { GetServerSideProps } from 'next';
import AvthorDetail from '@/components/screens/avthor-detail/AvthorDetail';
import { BOOKS_FOR_PAGE, API_URL } from '@/helpers/variables';
import { IAvthorDetail } from '@/interfaces/avthorDetail.interface';
import { IPopularBooksCustomData } from '@/interfaces/popularBooksCustom.interface';
import { ISimilarAuthors } from '@/interfaces/similarAuthors';

interface IAvthorSortingVisitedPageDynamicProps {
  books: IAvthorDetail;
  popularSlider: IPopularBooksCustomData;
  similarAuthors: ISimilarAuthors;
}

const AvthorSortingVisitedPageDynamic: NextPage<IAvthorSortingVisitedPageDynamicProps> = ({ books, similarAuthors }) => {
  return <AvthorDetail books={books} sortingName="по названию" sortingUrl={'sorting/nazvanie'} similarAuthors={similarAuthors} />;
};

export const getServerSideProps: GetServerSideProps = async (context) => {
  const { alias } = context.query;

  const [booksRes, similarAuthorsRes] = await Promise.all([fetch(`${API_URL}satellite/author/info/${alias}?page=1&page_size=${BOOKS_FOR_PAGE}&sort_field=alphabet&sort_reversed=false`), fetch(`${API_URL}satellite/similar/author/${alias}`)]);
  const [books, similarAuthors] = await Promise.all([booksRes.json(), similarAuthorsRes.json()]);

  // Check fetch error
  if (!booksRes.ok) {
    console.table(`Error ${booksRes.status}. Api: ${booksRes.url}`);
    return {
      notFound: true,
    };
  }

  return {
    props: {
      books,

      similarAuthors,
    },
  };
};

export default AvthorSortingVisitedPageDynamic;
